// extracted by mini-css-extract-plugin
module.exports = {"self":"ViewOneFeedbackItemDialog_self__X3E8U"};